// /src/mocks/cursos.ts
import { ICurso } from '../types';

export const mockCursos: ICurso[] = [
  {
    id: 'curso-1',
    titulo: 'Introducción a ISO 45001:2018',
    descripcion: 'Aprende los fundamentos del Sistema de Gestión de Seguridad y Salud en el Trabajo según ISO 45001.',
    contenido: 'https://www.youtube.com/watch?v=Zxc4NdzGx1Q',
    completado: false,
  },
  {
    id: 'curso-2',
    titulo: 'Identificación de Peligros y Evaluación de Riesgos',
    descripcion: 'Metodologías y herramientas para identificar peligros y evaluar riesgos en el lugar de trabajo.',
    contenido: 'https://www.youtube.com/watch?v=LatBNnHA8ss',
    completado: false,
  },
  {
    id: 'curso-3',
    titulo: 'Auditorías Internas de Sistemas de Gestión',
    descripcion: 'Cómo planificar, ejecutar y reportar auditorías internas efectivas.',
    contenido: 'https://www.youtube.com/watch?v=SATi2IrDPXw',
    completado: false,
  },
  {
    id: 'curso-4',
    titulo: 'ISO 9001:2015 - Gestión de Calidad',
    descripcion: 'Comprende los requisitos y beneficios del Sistema de Gestión de Calidad ISO 9001.',
    contenido: 'https://www.youtube.com/watch?v=fzTV-Ebk5Cg',
    completado: false,
  },
];
